import React, { useEffect, useMemo } from 'react'
import styles from 'components/Filters/FilterPanel/subcomponents/SubButtons/subbuttons.module.scss'
import { Button, Dropdown, Icon, Popover, Typography } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import FilterComponents from 'components/Filters/FilterPanel/subcomponents'
import isEqual from 'lodash/isEqual'

const Selector = ({ filterManager, filterKey, breakpoints }) => {
  const { t } = useTranslation()
  const { clearFilter, filters, configuration, updateFilter, initial } = filterManager
  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()

  const popoverState = usePopupState({
    variant: 'popover',
    id: 'selector-popover-' + filterKey,
    breakpoints: {
      0: {
        variant: 'bottomSheet',
        hasBackdrop: true,
        showLabel: true,
      },
      960: {
        variant: 'popover',
        hasBackdrop: false,
      },
    },
  })

  const Component = useMemo(() => {
    const El = FilterComponents[configuration[filterKey].type]

    return El ? (
      <El
        name={filterKey}
        defaultValue={initial[filterKey]}
        value={filters?.[filterKey]}
        key={'subbutton-selector-' + filterKey}
        filterManager={filterManager}
        onApply={(update) => {
          updateFilter(update)
          popoverState.close()
        }}
        {...configuration[filterKey]}
      />
    ) : null
  }, [configuration, filterKey, filterManager, updateFilter, filters])

  const value = useMemo(() => {
    const config = configuration?.[filterKey]
    const from = filters?.[configuration?.[filterKey]?.nameFrom]
    const to = filters?.[configuration?.[filterKey]?.nameTo]

    return from || to
      ? `${from && parseFloat(from) > 0 ? from : '0.00'} — ${to ?? '∞'} ${config.unit}`
      : t('common::select_value')
  }, [filters, t])

  const showClearButton = useMemo(
    () =>
      ((Array.isArray(filters?.[filterKey]) && filters?.[filterKey]?.length > 0) ||
        filters?.[filterKey] !== undefined) &&
      !isEqual(filters?.[filterKey], initial?.[filterKey]),
    [filters, initial],
  )

  useEffect(() => {
    breakpoints.lg && popoverState.close()
  }, [breakpoints])

  return (
    <>
      <div
        className={styles['subbuttons-filter']}
        key={'applied-filter-' + filterKey}
      >
        <Typography
          variant={'Body-15'}
          {...(!breakpoints.lg ? bindTrigger(popoverState) : {})}
        >
          {t(configuration[filterKey].label)}: {value}
        </Typography>

        {showClearButton && (
          <Button
            type="button"
            noLabel
            title={t('common::buttons.clear')}
            onClick={() => clearFilter(filterKey)}
            size={'s'}
            variant={'link'}
            noHover
            className={styles['subbuttons-filter__delete-button']}
            startIcon={<Icon name={'close'} />}
          />
        )}
      </div>

      <Popover
        {...bindPopover(popoverState)}
        hasBackdrop
        label={t(configuration[filterKey].label)}
        bodyClassName={styles['subbuttons-filter__popover-inner']}
      >
        <Dropdown>
          {/*<DropdownText color={'Label-Primary'}>*/}
          {/*  {t(configuration[filterKey].label)}*/}
          {/*</DropdownText>*/}
          {Component}
        </Dropdown>
      </Popover>
    </>
  )
}

Selector.propTypes = {
  filterManager: PropTypes.object,
  filterKey: PropTypes.string,
  breakpoints: PropTypes.object,
}

export default Selector
